'use client';

import type { IChromeConfig } from '@repo/web-chrome/chrome-config/chrome-config';
import { ChromeConfigContext } from '@repo/web-chrome/chrome-config/chrome-config-context';
import { useContext } from 'react';

export function useChromeConfig(): IChromeConfig {
  const config = useContext(ChromeConfigContext);
  if (!config) {
    throw new Error('useChromeConfig must be used inside WebChromeProvider');
  }
  return config;
}
